<template>
  <div class="view">
    <div class="avatar">
      <img :src="`./images/imavatars/${avatar}.png`" :alt="avatar"/>
      <div class="name">{{name}}</div>
    </div>
    <div class="content panel">
      <div class="head">
        <div class="title">
          {{blank(title) ? '—' : title}}
        </div>
        <div class="actions">
          <button class="share" type="button" :title="$t('im.share')" @click="share">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="M12 3v12M7.5 7.5L12 3l4.5 4.5M5 12v7a2 2 0 002 2h10a2 2 0 002-2v-7" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="done" v-if="copied">&#10003;</span>
          </button>
          <LikeButton :pid="pid" :count="likes"/>
        </div>
      </div>
      <div class="image" v-for="item in attachments" :key="`${pid}-attach-${item}`">
        <img
          :src="`./images/imfiles/${item.toLowerCase()}.jpg`"
          :alt="item"
          @click="viewImage(`./images/imfiles/${item.toLowerCase()}.jpg`)">
      </div>
      <div class="text" v-if="!blank(text)" v-html="text"/>
      <div class="text none" v-else-if="!attachments || !attachments.length">&mdash;</div>
    </div>
  </div>
</template>

<script>
import lightbox from '@/lightbox';
import LikeButton from '../LikeButton';

export default {
  name: 'PostView',
  props: ['avatar', 'name', 'pid', 'title', 'text', 'attachments', 'likes'],
  components: { LikeButton },
  data() {
    return { copied: false };
  },
  methods: {
    // "share": put the link of this post into the clipboard
    share() {
      const url = location.href;
      const done = () => {
        this.copied = true;
        setTimeout(() => { this.copied = false; }, 1500);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(url).then(done, () => window.prompt('', url));
      } else {
        window.prompt('', url);
      }
    },
    // game data uses full-width spaces / &nbsp; / empty tags for "nothing here"
    blank(s) {
      return !s || !String(s).replace(/<[^>]*>|&nbsp;|[\s\u200b]/g, '');
    },
    viewImage(url) {
      lightbox.show(url);
    }
  }
}
</script>

<style lang="scss" scoped>
.view {
  margin: 14px 18px 8px 8px;
  display: flex;
  align-items: flex-start;
  .avatar {
    min-width: 96px;
    max-width: 96px;
    user-select: none;
    text-align: center;
    @media screen and (max-width: 767px) {
      min-width: 72px;
      max-width: 72px;
    }
    img {
      width: 56px;
      height: 56px;
      border-radius: 50%;
      border: 2px solid var(--line);
      background: var(--surface);
      box-sizing: border-box;
      object-fit: cover;
    }
    .name {
      margin-top: 2px;
      font-size: .8em;
      color: var(--dim);
      word-break: break-all;
      line-height: 1.1;
    }
  }
  .content {
    flex: 1;
    min-width: 0;
    white-space: pre-line;
    padding: 14px 20px 8px;
    box-sizing: border-box;
    .head {
      display: flex;
      align-items: flex-start;
      gap: 16px;
      margin-bottom: 1em;
    }
    .title {
      flex: 1;
      min-width: 0;
      font-size: 1.35em;
      padding-top: .3em;
      color: var(--accent);
      text-shadow: 0 0 10px var(--line-dim);
    }
    .text {
      font-size: 1.1em;
      line-height: 1.35;
      word-break: break-word;
    }
    .none {
      color: var(--dim);
    }
    .image {
      margin-bottom: 18px;
      img {
        width: 12em;
        max-width: 100%;
        cursor: pointer;
        border: 1px solid var(--line-dim);
      }
    }
    .actions {
      flex: none;
      display: flex;
      align-items: center;
      gap: 8px;
    }
    .share {
      position: relative;
      width: 2.2em;
      height: 2.2em;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50%;
      color: var(--accent);
      background: var(--panel-hi);
      svg { width: 1.15em; height: 1.15em; }
      &:hover { box-shadow: 0 0 12px var(--accent); }
      .done { position: absolute; right: -.3em; top: -.4em; font-size: .7em; color: var(--accent); }
    }
  }
}
</style>
